export default "__VITE_ASSET__51d6803e__"